<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 5.5L11.5 1.5L16 6L12 10L10.5 14L9 15.5L5.5 12L2 8.5L3.5 7L7.5 5.5Z" fill="#FFA100" fill-opacity="0.5"/>
<path d="M5.5 12L1 16.5M11 1L16.5 6.5M11.5 1.5L7.5 5.5L3.5 7L2 8.5L9 15.5L10.5 14L12 10L16 6L11.5 1.5Z" stroke="#FFA100" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
